/** Money of the ads agent: integer minor units of the ad account currency, as the server keeps it. */

/** Meta's offset-1 currencies, as the server's `ads/meta/money.ts` lists them. */
const WHOLE_UNIT_CURRENCIES = ['CLP', 'COP', 'CRC', 'HUF', 'IDR', 'ISK', 'JPY', 'KRW', 'PYG', 'TWD', 'VND'];

export function minorFactor(currency: string): number {
  return WHOLE_UNIT_CURRENCIES.includes(currency) ? 1 : 100;
}

export function formatMoney(minor: number, currency: string): string {
  const factor = minorFactor(currency);
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency,
    minimumFractionDigits: factor === 1 ? 0 : 2,
    maximumFractionDigits: factor === 1 ? 0 : 2,
  }).format(minor / factor);
}
